<template>
  <List />
</template>

<script>
import List from '@/components/users/List'

export default {
  components: { List }
}
</script>
